import {en} from './en';
import {nl} from './nl';

export const i18n = {
    en: en,
    nl: nl
}